import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import axios from "axios";
import {format, isSameYear, parse, parseISO} from "date-fns";
import {getData as getCountries} from 'country-list';

export const messageAlert = withReactContent(Swal);
export const showAlertAutoDis = (alert, callback = null) => {
    // let timerInterval
    messageAlert.fire({
        title: alert.title,
        text: alert.text,
        html: alert.html,
        width: 'auto',
        timer: alert.manualClose ? undefined : 5000,
        confirmButtonColor: '#00b7f0',
        // timerProgressBar: true,
        /*didOpen: () => {
            MySwal.showLoading()
            timerInterval = setInterval(() => {
                const content = MySwal.getContent()
                if (content) {
                    const b = content.querySelector('b')
                    if (b) {
                        b.textContent = MySwal.getTimerLeft()
                    }
                }
            }, 100)
        },*/
        // willClose: () => {
        //     clearInterval(timerInterval)
        // }
    }).then(() => {
        if (callback)
            callback();
    });
}
export const showMessage = async (obj, callback = null, bandera = false) => {
    if ('action' in obj) {
        const {confirmButtonText, width, action, actionParams, actionUrl, title, html} = obj;
        let mensaje = {confirmButtonText, width, html, customClass: {confirmButton: 'btnConfirmar'}};
        mensaje.html = `<div>
                <div class="message"><span class="subTitleConfirmation">${title}</span>
                <br/>
                <br/>
                ${html}
                </div>
                </div>`;
        if (obj['redirect']) {
            messageAlert.fire(mensaje).then(() => {
                const fn = window[action];
                fn.call(null, actionUrl)
            });
        } else {
            messageAlert.fire(mensaje).then(() => {
                window[action] = eval(action);
                const fn = window[action];
                if (typeof fn === 'function')
                    fn(actionParams, actionUrl);
            });
        }
    } else {
        const mensaje = `<div>
                <div class="message"><span class="subTitleConfirmation">${obj.title}</span>
                <br/>
                <br/>
                ${obj.message}
                </div>
                </div>`;

        const confirmButtonText = bandera ? obj.confirmButtonText : trans('modal.ok');

        const confirmado = await messageAlert.fire({
            html: mensaje,
            confirmButtonText,
            cancelButtonText: 'No',
            showCancelButton: !bandera,
            showCloseButton: !bandera,
            width: bandera ? obj.width : 'auto',
            reverseButtons: !bandera,
            customClass: {
                confirmButton: 'btnConfirmar'
            }
        });

        if (callback)
            callback(confirmado);
    }
};

export const getStepsBooking = () => {
    return ['Select your room', 'Review', 'Activities', 'Information', 'Terms and Conditions', 'Payment', 'Confirmation'];
};
export const getStepsGuestInfo = () => {
    return ['Personal Information', 'Medical & Insurance', 'Diving', 'Extra Activities'];
};
Number.prototype.formatMoney = function (c, d, t) {
    let n, q, f, z, s, i, j;
    n = this;
    q = isNaN(c = Math.abs(c)) ? 2 : c;
    f = d === undefined ? '.' : d;
    z = t === undefined ? ',' : t;
    s = n < 0 ? '-' : '';
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(q)));
    j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + z : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + z) + (q ? f + Math.abs(n - i).toFixed(q).slice(2) : '');
};
export default Number;
export const containsObj = (obj, list, criteria) => {
    for (let x in list) {
        if (list.hasOwnProperty(x) && list[x][criteria] === obj[criteria]) {
            return true;
        }
    }
    return false;
};
export const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
};
export const redirectTo = (url) => {
    const prefix = window['siteUrl'];
    window.location.replace(prefix + url);
};
export const requestLoader = async (url, params = {}, callback = null, isPost = true) => {
    const loader = $('#cover');
    const prefix = window['siteUrl'];
    loader.show();
    if (params)
        params.source = window['bookingSource'];
    if (isPost) {
        const response = await axios.post(prefix + url, params);
        loader.hide();
        if (typeof callback === 'function')
            return callback(response);
        else
            return response;

    }
};

export const requestApi = async (url, method = 'GET', params = {}, callback = null) => {
    // const loader = document.querySelector(".preloader");
    const loader = document.querySelector("#cover");
    // console.log(params);
    const baseURL = axios.defaults.baseURL;
    if (!baseURL) {
        const apiURL = document.head.querySelector('meta[name="api-url"]');
        axios.defaults.baseURL = apiURL.content;
    }
    if (params)
        params.source = window['bookingSource'];
    // loader.style.opacity = "1";
    // loader.style.visibility = "visible";
    loader.style.display='block';
    try {
        const configuration = {
            method,
            url
        };

        if (method === 'GET')
            configuration.params = params;
        else
            configuration.data = params;


        const loginToken = localStorage.getItem('user');
        const apiKey = localStorage.getItem('apiKey');
        if (apiKey) {
            configuration.headers = {'Authorization': `${apiKey}`};
            const WidgetURL = document.head.querySelector('meta[name="widget-url"]');
            axios.defaults.baseURL = WidgetURL.content;
        } else if (loginToken)
            configuration.headers = {'Authorization': `Bearer ${loginToken}`};

        const response = await axios(configuration);
        // loader.style.opacity = "0";
        // loader.style.visibility = "hidden";
        loader.style.display='none';
        if (typeof callback === 'function')
            return callback(response);
        else
            return response;

    } catch (e) {
        // loader.style.opacity = "0";
        // loader.style.visibility = "hidden";
        loader.style.display='none';
        throw {data: e.response.data, status: e.response.status};
    }

};

export const validateUser = async () => {
    const baseURL = axios.defaults.baseURL;
    if (!baseURL) {
        const apiURL = document.head.querySelector('meta[name="api-url"]');
        axios.defaults.baseURL = apiURL.content;
    }

    const token = localStorage.getItem('user');
    const {data} = await axios.post('/customer/validate', {token});
    return data;

};

export const getPrefSex = (availBeds = []) => {
    let prefSex = '';
    if (availBeds.length > 0) {
        if (availBeds.every(berth => berth.prefSex === 'F'))
            prefSex = 'Female';
        else if (availBeds.every(berth => berth.prefSex === 'M'))
            prefSex = 'Male';
    }

    return prefSex;
};

export const getSpacesBySex = (roomType) => {
    let maleSpaces = 0, femaleSpaces = 0;
    roomType.availBeds.map(berth => {
        switch (berth.prefSex) {
            case 'M':
                maleSpaces += berth.avail;
                break;
            case 'F':
                femaleSpaces += berth.avail;
                break;
            default:
                maleSpaces += berth.avail;
                femaleSpaces += berth.avail;
        }
    });
    return {maleSpaces, femaleSpaces};
}

export const canAddSingleSpace = (roomSelections, roomType, singleCheck = false) => {
    const availableSpaces = roomType.spaces;
    if (!roomType.availBeds.some(r => r.avail === 2)) return false;

    let currentSpaces = roomSelections.length + 1;
    const hasSingle = roomSelections.some(s => s.singleOccupancy);
    if (hasSingle || (!hasSingle && singleCheck)) currentSpaces++;
    return currentSpaces <= availableSpaces;
};

export const canChangeGender = (selectedRooms, selectionId, roomType, gender) => {
    if (parseInt(roomType.index) === 5 || parseInt(roomType.index) === 3)
        return true;
    let {maleSpaces, femaleSpaces} = getSpacesBySex(roomType);

    // Create a clone of the selected rooms to calculate the spaces with the new state
    // without mutating the current object
    const spacesWithNewState = _.cloneDeep(selectedRooms);
    spacesWithNewState.map(space => {
        if (space.id === selectionId)
            space['sex'] = gender;
    });

    const maleSpacesArray = spacesWithNewState.filter(u => u.index === roomType.index && u.sex === 'male');
    const femaleSpacesArray = spacesWithNewState.filter(u => u.index === roomType.index && u.sex === 'female');

    let usedMaleSpaces = maleSpacesArray.length;
    if (maleSpacesArray.some(m => m.singleOccupancy)) {
        if (!roomType.availBeds.some(r => r.avail === 2)) return false;
        usedMaleSpaces++;
        femaleSpaces -= 2;
    }
    let usedFemaleSpaces = femaleSpacesArray.length;
    if (femaleSpacesArray.some(f => f.singleOccupancy)) {
        if (!roomType.availBeds.some(r => r.avail === 2)) return false;
        usedFemaleSpaces++;
        maleSpaces -= 2;
    }

    return !(usedFemaleSpaces > femaleSpaces || usedMaleSpaces > maleSpaces);
};

export const getNewSelectedRooms = (selectedRooms, roomType, selectionId, gender) => {
    const spacesWithNewState = _.cloneDeep(selectedRooms);

    for (let room of spacesWithNewState) {
        if (room.id === selectionId)
            room['sex'] = gender;
    }

    return spacesWithNewState;
};

export const getRoomTotal = (room, selectedSpaces = []) => selectedSpaces.reduce((acc, curr) => curr.singleOccupancy ? acc + room.price.single : acc + room.price.pretax, 0);

export const getRefundable = (room, selectedSpaces = []) => {
    return selectedSpaces.reduce((acc, curr) => curr.singleDisabled ? acc + room.price.singleRefundable : acc + room.price.refundable, 0);

    // selectedSpaces.reduce((acc, curr) => {
    // 	console.log(curr.singleOccupancy === false ? acc + room.price.refundable : acc + room.price.singleRefundable);
    // 	console.log(curr.singleDisabled ? acc + room.price.singleRefundable : acc + room.price.refundable);
    // }, 0);
}

export const getItinerary = (activities, selectedActivities, trip) => {
    const activityList = [];

    if (activities.extra && activities.extra.length > 0)
        for (let extra in selectedActivities.extra) {
            const availabilityId = selectedActivities.extra[extra];
            const extraObj = activities.extra.find(a => a.id === parseInt(extra));
            const availability = extraObj.availabilities[availabilityId];
            if (!availability) continue;
            const date = availability.date;
            const formattedDate = parse(date, "yyyy-MM-dd'T'HH:mm:ss", new Date());

            activityList.push({
                id: extraObj.id,
                name: extraObj.name.replace('Extra', ''),
                date: formattedDate,
                type: 'extra'
            });
        }

    if (activities.complimentary && activities.complimentary.length > 0)
        for (let complimentary in selectedActivities.complimentary) {
            const availabilityId = selectedActivities.complimentary[complimentary];
            const compObj = activities.complimentary.find(a => a.id === parseInt(complimentary));
            const availability = compObj.availabilities[availabilityId];
            if (!availability) continue;
            const date = availability.date;
            const formattedDate = parse(date, "yyyy-MM-dd'T'HH:mm:ss", new Date());
            activityList.push({
                id: compObj.id,
                name: compObj.name.replace('Complimentary', ''),
                date: formattedDate,
                type: 'complimentary'
            });
        }

    if (trip && Object.keys(trip).length > 0) {
        const tripDate = parse(trip.boarddate, 'yyyy-MM-dd', new Date());
        const tripReturnDate = parse(trip.returndate, 'yyyy-MM-dd', new Date());
        activityList.push({
            id: trip.TripId,
            name: trip.shortcomment,
            date: tripDate,
            returnDate: tripReturnDate,
            type: 'trip'
        });

    }
    activityList.sort((a, b) => a.date.getTime() - b.date.getTime());
    return groupActivitiesByDate(activityList);
};
export const shouldShowTime = (activityDate) => {
    const time = format(activityDate, 'h:mm a');
    return time !== '12:00 AM';
};

export const getItineraryFH = (activities, selectedActivities) => {
    const activityList = [];

    if (activities.extra && activities.extra.length > 0) {
        Object.keys(selectedActivities.extra).forEach((company) => {
            Object.keys(selectedActivities.extra[company]).forEach((activityId) => {
                const availabilities = selectedActivities.extra[company][activityId];

                if (availabilities && typeof availabilities === 'object') {
                    Object.keys(availabilities).forEach((availabilityId) => {
                        const availability = availabilities[availabilityId];
                        if (availability?.data?.date) {
                            const extraObj = activities.extra.find(a => a.id === parseInt(activityId));
                            if (extraObj) {
                                const formattedDate = parse(availability.data.date, "yyyy-MM-dd'T'HH:mm:ss", new Date());

                                activityList.push({
                                    id: extraObj.id,
                                    company: extraObj.company,
                                    availabilityId,
                                    name: extraObj.name.replace('Extra', ''),
                                    date: formattedDate,
                                    type: 'extra'
                                });
                            }
                        }
                    });
                }
            });
        });
    }

    activityList.sort((a, b) => a.date.getTime() - b.date.getTime());
    return groupActivitiesByDate(activityList);
};

export const getMaxPaxFromExtras = (extra,multiActivity=false) => {
    if (!extra) return 200;

    let maxPax = 0;
    let availabilityCount = 0;

    Object.keys(extra).forEach((company) => {
        Object.keys(extra[company]).forEach((activityId) => {
            const availabilities = extra[company][activityId];
            if (availabilities && typeof availabilities === 'object') {
                Object.keys(availabilities).forEach((availabilityId) => {
                    const availability = availabilities[availabilityId];
                    if (availability?.pax) {
                        availabilityCount++;
                        if (availability.pax > maxPax) {
                            maxPax = availability.pax;
                        }
                    }
                });
            }
        });
    });

    return availabilityCount <= 1 && multiActivity ? 200 : maxPax;
};


const groupActivitiesByDate = (itinerary = []) => {
    return _.groupBy(itinerary, (activity) => {
        if (activity.type === 'trip')
            return `${format(activity.date, 'yyyy-MM-dd')}/${format(activity.returnDate, 'yyyy-MM-dd')}`;
        return format(activity.date, 'yyyy-MM-dd');
    });

};


export const steps = [
    {index: 0, url: '/', label: 'Select Trip'},
    {index: 1, url: '/select-room', label: 'Select Room'},
    {index: 2, url: '/review', label: 'Review'},
    {index: 3, url: '/activities', label: 'Activities'},
    {index: 4, url: '/information', label: 'Information'},
    {index: 5, url: '/terms', label: 'Terms & Conditions'},
    {index: 6, url: '/payment', label: 'Payment'},
    {index: 7, url: '/confirmation', label: 'Confirmation'},
];

export const dealerSteps = [
    {index: 0, url: '/schedule', label: 'Select Trip'},
    {index: 1, url: '/select-room', label: 'Select Room'},
    {index: 2, url: '/information', label: 'Information'},
    {index: 3, url: '/review', label: 'Review'},
    {index: 4, url: '/activities', label: 'Activities'},
    {index: 5, url: '/terms', label: 'Terms & Conditions'},
    {index: 6, url: '/payment', label: 'Payment'},
    {index: 7, url: '/confirmation', label: 'Confirmation'},
];

export const widgetsSteps = [
    {index: 0, url: `/plugin?apiKey=${localStorage.getItem('apiKey')}`, label: 'Select Trip'},
    {index: 1, url: '/select-room', label: 'Select Room'},
    {index: 2, url: '/review', label: 'Review'},
    {index: 3, url: '/information', label: 'Information'},
    {index: 4, url: '/confirmation', label: 'Confirmation'},
];
export const dayTripSteps = [
    {index: 0, url: '/', label: 'Select Day Trip'},
    {index: 1, url: '/book', label: 'Book Activity'},
    {index: 2, url: '/summary', label: 'Summary'},
    {index: 3, url: '/payment', label: 'Payment'},
    {index: 4, url: '/confirmation', label: 'Confirmation'},
];

export const isDealerSite = () => {
    const dealerSite = document.querySelector("meta[name='dealer']");
    return dealerSite && dealerSite.getAttribute('content') === '1';
};

export const isWidget = () => {
    const url = window.location.href;
    return url.includes("iframe") || url.includes("plugin");
};
export const isDayTrip = () => {
    const url = window.location.href;
    return url.includes("day-trips");
};


export const getCurrentSteps = () => {
    if (isDealerSite()){
        if (isDayTrip())
            return dayTripSteps;
        return dealerSteps;
    }
    if (isWidget())
        return widgetsSteps;
    if (isDayTrip())
        return dayTripSteps;
    return steps;
};

export const getStepFromUrl = (url = '/') => {
    const _steps = getCurrentSteps();
    const currentUrl = /.*\/([^?]+)/.exec(url)[1];

    const stepNumber = _steps.find(s => s.url === `/${currentUrl}`);
    return stepNumber ? stepNumber.index : 0;

};

export const getNextStep = (currentStep) => {
    if (!currentStep) return {index: 0, url: '/', label: 'Select Room'};
    const _steps = getCurrentSteps();

    return _steps.find(s => s.index === currentStep + 1);
};

export const getPreviousStep = (currentStep) => {
    if (!currentStep || currentStep < 1) return {index: 0, url: '/', label: 'Index'};
    const _steps = getCurrentSteps();

    return _steps.find(s => s.index === currentStep - 1);
};

export const showInfo = (that) => {
    $('#moreInfo' + that).toggle();
};

export const parseJwt = (token) => {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
        return null;
    }
};

export const getFormattedDate = (activityDate) => {
    const parsedDate = parse(activityDate, "yyyy-MM-dd'T'HH:mm:ss", new Date());
    return `${format(parsedDate, 'h:mm a')} on ${format(parsedDate, 'MMMM dd, yyyy')}`;
};

export const ExtraActivityDate = (date) => {
    const nd = new Date(date);
    return format(nd, "h:mmaa - LLLL d, yyyy");
};

export const restartBooking = (tripId) => {
    sessionStorage.clear();
    if (!isWidget())
        window.location.href = `${window['siteUrl']}booking/${tripId}/select-room`;
    else
        window.location.href = `${window['widgetURL']}plugin/${tripId}/select-room`;
};

export const getTripFormattedDate = (boardDate, returnDate) => {
    const startDate = parse(boardDate, 'yyyy-MM-dd', new Date());
    const endDate = parse(returnDate, 'yyyy-MM-dd', new Date());
    let formattedStringDate = `${format(startDate, 'LLLL d yyyy')} - `;

    formattedStringDate += format(endDate, 'LLLL d yyyy');

    if (isSameYear(startDate, endDate))
        formattedStringDate = formattedStringDate.replace(format(startDate, 'yyyy'), '');

    return formattedStringDate;
};
export const getDayTripFormattedDate = (date) => {
    const startDate = parseISO(date);
    return  format(startDate, 'LLLL d yyyy');
};

export const parseDate = (date) => {
    if (!date || date === '0000-00-00') return null;
    return parse(date, 'yyyy-MM-dd', new Date());
};

export const parseTime = (time = null) => {
    if (!time)
        // return parse('noon', 'bb', new Date());
        return null;
    try {
        return parse(time, 'hh:mm a', new Date());
    } catch (e) {
        // return parse('noon', 'bb', new Date());
        return null;
    }
}

export const validateForm = async (rules, data, title = 'Form Validation') => {
    let valid = false;
    await rules.isValid(data).then((result) => {
        valid = result;
    });
    if (!valid)
        await showErrors(rules, data, title);
    return valid;
};

export const showErrors = async (rules, data, title) => {
    await rules.validate(data, {abortEarly: false}).catch((err) => {
        showAlertAutoDis({
            title: `<span style="font-size:25px">${title}</span>`,
            html: `<p  style="font-size:16px">The following error(s) have been found:<br/>${err.errors.join("<br/>")}</p>`
        });
    });
};

export const getCountryList = () => {
    const countries = getCountries();
    const taiwan = countries.find(country => country.code === 'TW');
    taiwan.name = 'Taiwan';
    return countries;
}

export const bookingActions = (page, action, value, loc = '', trip_date = '', price = 0) => {
    if (!gtag || !dataLayer) return;
    // console.log(page, action, value);
    dataLayer.push({
        'event': 'booking_actions',
        'page': page, // Page
        'action': action, // Action
        'value': value, // Value
        'location': loc,
        'trip_date': trip_date,
        'price': price
    });
}
export const registerFindTrip = () => {
    if (!gtag || !window['gtaEvent1']) return;

    gtag('event', 'conversion', {
        'send_to': window['gtaEvent1'],
        'value': 2.0,
        'currency': 'USD'
    });
}
export const registerBookingTrip = () => {
    if (!gtag || !window['gtaEvent2']) return;

    gtag('event', 'conversion', {
        'send_to': window['gtaEvent2'],
    });
}
export const registerConfirmedBooking = () => {
    if (!gtag || !window['gtaEvent3']) return;

    gtag('event', 'conversion', {
        'send_to': window['gtaEvent3'],
        'transaction_id': ''
    });
}

export const showPopupVideo = (alert, callback = null) => {
    messageAlert
        .fire({
            title: alert.title,
            html: alert.html,
            // background: "transparent",
            // color: '#fff',
            width: "900px",
            showConfirmButton: false,
            showCloseButton: true,
        })
        .then(() => {
            if (callback) callback();
        });
};

export const newRequestApi = async (
    url,
    method = "GET",
    params = {},
    callback = null,
    preloader = true
) => {
    const loader = document.querySelector(".preloader");

    const baseURL = axios.defaults.baseURL;
    if (!baseURL) {
        const apiURL = document.head.querySelector('meta[name="api-url"]');
        axios.defaults.baseURL = apiURL.content;
    }
    if (params)
        params.source = window['bookingSource'];
    if (preloader) {
        loader.style.opacity = "1";
        loader.style.visibility = "visible";
    }

    try {
        const configuration = {
            method,
            url,
        };

        if (method === "GET") configuration.params = params;
        else configuration.data = params;

        const loginToken = localStorage.getItem("user");
        let apiKey;
        if (!isWidget() && localStorage.getItem('apiKey'))
            localStorage.removeItem('apiKey');
        if (localStorage.getItem('apiKey'))
            apiKey = localStorage.getItem('apiKey');
        if (apiKey) {
            configuration.headers = {'Authorization': `${apiKey}`};
            const WidgetURL = document.head.querySelector('meta[name="widget-url"]');
            axios.defaults.baseURL = WidgetURL.content;
        } else if (loginToken)
            configuration.headers = {Authorization: `Bearer ${loginToken}`};


        const response = await axios(configuration);
        if (preloader) {
            loader.style.opacity = "0";
            loader.style.visibility = "hidden";
        }

        if (typeof callback === "function") return callback(response);
        else return response;
    } catch (e) {
        if (preloader) {
            loader.style.opacity = "0";
            loader.style.visibility = "hidden";
        }
        // console.log(e);
        throw {data: e.response?.data, status: e.response?.status};
    }
};
export const getCompany = async () => {
    const {data: {data: {company}}} = await newRequestApi('get-company');
    return company;
};
export const slideUp = (target, duration = 700) => {
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.height = target.offsetHeight + "px";
    target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(() => {
        target.style.display = "none";
        target.style.removeProperty("height");
        target.style.removeProperty("padding-top");
        target.style.removeProperty("padding-bottom");
        target.style.removeProperty("margin-top");
        target.style.removeProperty("margin-bottom");
        target.style.removeProperty("overflow");
        target.style.removeProperty("transition-duration");
        target.style.removeProperty("transition-property");
        target.classList.remove("_slide");
    }, duration);
};

export const slideDown = (target, duration = 700) => {
    target.style.removeProperty("display");
    let display = window.getComputedStyle(target).display;
    if (display === "none") display = "block";

    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.height = height + "px";
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");
    window.setTimeout(() => {
        target.style.removeProperty("height");
        target.style.removeProperty("overflow");
        target.style.removeProperty("transition-duration");
        target.style.removeProperty("transition-property");
        target.classList.remove("_slide");
    }, duration);
};

export const getTripDates = (trip) => {
    const boardDate = parse(trip["boarddate"], "yyyy-MM-d", new Date());
    const returnDate = parse(trip["returndate"], "yyyy-MM-d", new Date());
    return `${format(boardDate, "MMM d")} - ${format(
        returnDate,
        "MMM d"
    )}, ${format(returnDate, "yyyy")}`;
};